export default __webpack_public_path__ + "2a416afc0e113295119d06120ed67ebb.png";